import {Component, OnInit} from '@angular/core';
import Commons from "../commons";
import {AuthRESTService} from '../../services/rest/auth-rest.service';
import {ActivatedRoute} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {Settings} from "../../../models/settings";
import { AppWidgetModule } from 'app/components/widgets/widget.module';
import { SharedModule } from 'app/shared.module';

@Component({
  standalone: true,
  imports: [SharedModule, AppWidgetModule],
	selector: 'settings',
	templateUrl: './settings.component.html',
	styleUrls: ['./settings.component.css']
})
export class SettingsComponent extends Commons implements OnInit {
	settings: Settings = new Settings();
	logoLabel: string = 'oaclient.logo';
	logoImageUrls: string [] = ['cas/configuration/settings/cas-logo'];
	logoSaveUrl: string = 'configuration/settings/save-logo';
	errorMessage;

	constructor(private route: ActivatedRoute, private rest: AuthRESTService, toastr: ToastrService, translate: TranslateService) {
		super(toastr, translate);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			this.rest.get(`cas/configuration/settings`).subscribe((response) => {
				this.settings = response;
			}, err => this.errorHandler(err))
		});
	}

	onLogoChange(ev) {
		//this.logoImageUrls = ['cas/OAuth2/file/' + this.settings.code];
	}

	save(): void {
		this.clearNotifications();
		this.rest.post('configuration/settings', this.settings).subscribe(() => {
			this.addSuccess('general.saved')
		}, err => this.errorHandler(err))
	}
}
